module.exports = __webpack_public_path__ + "img/flomhendelser.dec2a1ee.jpg";